// extracted by mini-css-extract-plugin
module.exports = {"assessment-icon":"assessment-icon_assessment-icon__8PeHp","completed":"assessment-icon_completed__CaK_Y"};